// extracted by mini-css-extract-plugin
export default {"logo":"configurator-web-logo"};